import { render, staticRenderFns } from "./UpdateReferralUnit.vue?vue&type=template&id=5a0da59a&scoped=true"
import script from "./UpdateReferralUnit.vue?vue&type=script&lang=js"
export * from "./UpdateReferralUnit.vue?vue&type=script&lang=js"
import style0 from "./UpdateReferralUnit.vue?vue&type=style&index=0&id=5a0da59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0da59a",
  null
  
)

export default component.exports